export const LogoMark = ({ size = 56 }) => (
  <img
    src="/logo.png"
    alt="JC Colors LLC — Drywall & Painting logo"
    width={size}
    height={size}
    className="rounded-lg object-contain"
  />
);

export const Logo = ({ dark = false }) => (
  <span
    className={`inline-flex items-center ${
      dark ? "rounded-xl bg-white p-2 shadow-sm" : ""
    }`}
  >
    <img
      src="/logo.png"
      alt="JC Colors LLC — Drywall & Painting logo"
      className={`w-auto rounded-md object-contain ${dark ? "h-16" : "h-16 sm:h-20"}`}
    />
  </span>
);
